import * as signalR from "@microsoft/signalr";

export class Logger implements signalR.ILogger {
  log(logLevel: signalR.LogLevel, message: string): void {
    console.log(logLevel, message);
  }
}